'use strict';

angular.module('app')
    .controller('ChangeCreditCardCtrl', function($scope, $rootScope, $routeParams, paymentService, checkoutService, Booking, $route, gettextCatalog) {
        var vm = this;
        var confirmBooking = $route.current.locals.routeName === 'confirm_booking'

        paymentService.initStripe(paymentService.createPaymentForm.bind(paymentService));
        vm.cardChanged = false;

        vm.order = {
            uuid: $routeParams.uuid
        };

        vm.updateCard = updateCard;
        
        function updateCard(form) {
            form.$submitted = true;

            if (form.$valid) {
                var order = _.clone(vm.order);

                vm.loader = true;

                paymentService.createToken(order, function(response) {
                    var displayError = document.getElementById('stripe-errors');
                    
                    if (response.error) {
                        $scope.$apply(function() {
                            vm.loader = false;
                        })

                        displayError.innerHTML = '&#10006; ' + response.error.message;
                        
                        return true;
                    }
                    displayError.innerHTML = '';
                    order.token = response.token.id;
                    order.card_last4 = response.token.card.last4;
                    order.card_brand = response.token.card.brand || response.token.card.paymentMethod;
                    order.card_country = response.token.card.country;
                    order.paymentProcessor = 10;

                    checkoutService.updateCard(order).then(function() {
                        if (confirmBooking) {
                            Booking.confirmBooking($routeParams.uuid).then(function(){
                                vm.cardChanged = true;
                            });
                        } else {
                            vm.cardChanged = true;
                        }
                    }).catch(function(error) {
                        if (error.status === 500) {
                            return $rootScope.showNotify(gettextCatalog.getString('Something went wrong!'));
                        }

                        if (error.data) {
                            $rootScope.showNotify(_.map(error.data)[0], 5000);
                        }
                    }).finally(function() {
                        vm.loader = false;
                    });
                });
            }
        }
    });
